import { Cookies } from 'react-cookie';

import { TrapActivationHistory } from '../types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getTrapActivationHistory = async (slug: string, type: string, startDate?: string, endDate?: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/traps_signal_history/${type}/${slug}/`, {
    headers: {
      Authorization: token,
    },
    params: {
      startDate: startDate,
      endDate: endDate,
    },
  });
  return data.data as TrapActivationHistory[];
};
